export default function Done({ className = "fill-current" }) {
  return (
    <svg
      width="13"
      height="9"
      viewBox="0 0 13 9"
      xmlns="http://www.w3.org/2000/svg"
      className={className}>
      <path d="M5.52326 5.0625L2.45349 1.96875L0.5 3.9375L5.52326 9L12.5 1.96875L10.5465 0L5.52326 5.0625Z" />
    </svg>
  )
}
